import { timestamp, uuid } from 'drizzle-orm/pg-core';

export const id = {
  id: uuid('id').primaryKey().defaultRandom(),
};

export const timestamps = {
  createdAt: timestamp('created_at', {
    mode: 'date',
  })
    .notNull()
    .defaultNow(),
  updatedAt: timestamp('updated_at', {
    mode: 'date',
  })
    .notNull()
    .defaultNow(),
};

export const syncTracking = {
  lastSyncedAt: timestamp('last_synced_at', {
    mode: 'date',
  }),
  deletedAt: timestamp('deleted_at', {
    mode: 'date',
  }),
};
